import { render, staticRenderFns } from "./FloorEquipmentElectricity.vue?vue&type=template&id=c1871274&scoped=true&"
import script from "./FloorEquipmentElectricity.vue?vue&type=script&lang=js&"
export * from "./FloorEquipmentElectricity.vue?vue&type=script&lang=js&"
import style0 from "./FloorEquipmentElectricity.vue?vue&type=style&index=0&id=c1871274&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1871274",
  null
  
)

export default component.exports